var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-2",attrs:{"color":"indigo","block":"","dark":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v(" Galéria ")]),_c('v-dialog',{attrs:{"max-width":"600"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('app-carousel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }